import { useAuth0 } from "./DevAuth0Provider";
import { Icon } from "@iconify/react/dist/iconify.js";

const LogoutButton = () => {
  const { logout } = useAuth0();
  
  const handleLogout = (e) => {
    e.preventDefault();
    e.stopPropagation();
    console.log("LogoutButton: Initiating logout...");
    // Use the logout function from context which includes API call
    logout({ logoutReason: 'manual' });
  };
  
  return (
    <button 
      onClick={handleLogout} 
      className="logout-button w-full flex items-center justify-center"
    >
      <Icon icon="material-symbols:logout-rounded" className="text-xl text-accent mr-2" />
      <span>Sign Out</span>
    </button>
  );
};

export default LogoutButton;
